import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AccordionItem from '../../../../../../../../components/Accordion/AccordionItem';

const InsuredSectionDropdown = ({
  children,
  title,
  openByDefault = false,
  icons,
  isFetching = false,
  dusk = undefined,
  ...props
}) => {
  const [isOpen, toggleIsOpen] = useState(openByDefault);

  return (
    <AccordionItem
      dusk={dusk}
      icons={icons}
      isFetching={isFetching}
      isOpen={isOpen}
      mb={8}
      title={title}
      toggle={toggleIsOpen}
      {...props}
    >
      {children}
    </AccordionItem>
  );
};

InsuredSectionDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  icons: PropTypes.element,
  children: PropTypes.element.isRequired,
  openByDefault: PropTypes.bool,
  isFetching: PropTypes.bool,
  dusk: PropTypes.string
};

export default InsuredSectionDropdown;
